import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entry-voucher',
  templateUrl: './entry-voucher.component.html',
  styleUrls: ['./entry-voucher.component.scss']
})
export class EntryVoucherComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
